<template>
  <div class="ws-textbox">
    <div v-if="flight" class="block-item-flight row">
      <div class="container">
        <div class="row flightinfo text-center my-3">
          <div class="col-4 p-0">
            <div v-if="airline.lang_config && airline.lang_config.homepage_new.CONFIG[0].enabled">
              <div>{{ lang['homepage_new'].SFS_LANG_ROW_1 }}</div>
              <div class="airport-name text-dark">{{ flight.dep }}</div>
              <div class="flight-time-der">
                {{ moment(flight.std).format('D MMM') }}
                <div :style="flight.etd ? 'text-decoration: line-through' : ''">
                  {{ moment(flight.std).format('HH:mm') }}
                </div>
                <div v-if="flight.etd">
                  {{ moment(flight.etd).format('HH:mm') }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-4 p-0">
            <div>
              {{ !flight.carrier ? flight.flight_number : flight.carrier + flight.flight_no }}
            </div>
            <div class="frame-flight-img">
              <img src="@/assets/images/flight.png" alt="No image" />
            </div>
            <div v-if="airline.lang_config && airline.lang_config.homepage_new.CONFIG[2].enabled" class="flight-status">
              <p class="text-dark">{{ lang['homepage_new'].SFS_LANG_ROW_3 }}:</p>
              <p
                v-if="pax.fltref !== pax.first_fltref"
                :class="{
                  'status-new-flight': pax.fltref !== pax.first_fltref
                }"
              >
                {{ statusFlight }}
              </p>
              <p v-else class="status-flight">
                <span v-if="flight.irreg_reason">{{ lang['status_flight'][flight.irreg_reason] || flight.flight_status }}</span>
                <span v-else>{{ lang['status_flight']['NO_IRREG'] || flight.flight_status }}</span>
              </p>
            </div>
          </div>
          <div class="col-4 p-0">
            <div v-if="airline.lang_config && airline.lang_config.homepage_new.CONFIG[1].enabled">
              <div>{{ lang['homepage_new'].SFS_LANG_ROW_2 }}</div>
              <div class="airport-name text-dark">{{ flight.div }}</div>
              <div>
                {{ moment(flight.sta).format('D MMM') }}
                <div :style="flight.eta ? 'text-decoration: line-through' : ''">
                  {{ moment(flight.sta).format('HH:mm') }}
                </div>
                <div v-if="flight.eta">
                  {{ moment(flight.eta).format('HH:mm') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FlightInfo',
  props: {
    flight: {
      type: Object,
      default: () => {}
    },
    statusFlight: {
      type: String,
      default: ''
    },
    statusFlightDetail: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .block-item-flight {
  .flightinfo {
    color: #a4aabd;
    background-color: white;
    padding: 0;
    max-height: 166px;
  }

  .frame-flight-img {
    margin-top: 1.2rem;

    img {
      transform: var(--transform-flight-icon);
    }
  }

  .airport-name {
    font-size: 32pt;
  }

  .flight-status {
    margin: 16pt 0;
    letter-spacing: -0.3pt;
  }
}
.block-item {
  background-color: transparent !important;
}

.flight-status span {
  color: #07bcec;
}
</style>
